"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHub = void 0;

var _apiClient = require("../utils/apiClient");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var HUBS_BASE = 'hubs/v1';

var PORTAL_ID = _PortalIdParser.default.get();

var getHub = function getHub() {
  return (0, _apiClient.getApiClient)().get(HUBS_BASE + "/hubs/" + PORTAL_ID);
};

exports.getHub = getHub;


//////////////////
// WEBPACK FOOTER
// ./js/clients/hubsClient.js
// module id = 921
// module chunks = 192 210 211 212